import request from '@/utils/request'
import store from '../store'
export function GetPerformList(search) { // 写报告左侧列表
  search.departId = store.getters.departId
  return request({
    url: 'Examin/GetPerformList',
    method: 'post',
    data: search
  })
}
export function GetStatusList() { // 医疗状态列表
  return request({
    url: 'Common/GetStatusList',
    method: 'get'
  })
}

export function UpdateProcedureStatus(datas) { // 开始检查
  return request({
    url: 'Examin/UpdateProcedureStatus',
    method: 'post',
    data: datas
  })
}

export function BeginExamination(datas) { // 开始检查
  return request({
    url: 'Examin/BeginExamination',
    method: 'post',
    data: datas
  })
}
export function GetImageList(data) {
  return request({
    url: 'Examin/GetImageList',
    method: 'post',
    data: data
  })
}

